// Global body scroll-lock with reference counting so multiple stacked
// overlays (sheets, modals, nudges) never leave the page unscrollable.
let locks = 0;
const listeners = new Set();

function apply() {
  const html = document.documentElement;
  const b = document.body;
  if (locks > 0) {
    if (!html.dataset.locked) {
      html.style.overflow = "hidden";
      b.style.overflow = "hidden";
      html.dataset.locked = "1";
    }
  } else if (html.dataset.locked) {
    html.style.overflow = "";
    b.style.overflow = "";
    delete html.dataset.locked;
  }
  listeners.forEach((fn) => fn(locks));
}

export function pushLock() { locks += 1; apply(); }
export function popLock() { locks = Math.max(0, locks - 1); apply(); }
export function isLocked() { return locks > 0; }
export function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }
